/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/require-default-props */
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  List,
  ListItem,
  Slide,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { getApiCall, postApiCall } from 'api/apiService';
import {
  APP_SCALE,
  DESKTOP_BREAKPOINT,
  GET_APPRAISAL_PREFILL,
  STREET_TYPE_LIST,
} from 'constant/app.config';
import * as React from 'react';
import { useEffect } from 'react';
import AddListingModal from './AddListingModal';
import LegalDetailsAdd from './LegalDetailsAdd';
import PropertyCreationAddListing from './PropertyCreationAddListing';
import RetrexCampaign from './RetrexCampaign';
import { use } from 'react';
import { poppins400, poppins500 } from 'theme/common.style';
import { Pendingwarning } from './AppraisalPropertyPrefill';
const Close = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="1.41421"
        y1="1"
        x2="15"
        y2="14.5858"
        stroke="#6C2AD2"
        stroke-width="2"
        stroke-linecap="round"
      />
      <line
        x1="1"
        y1="14.5858"
        x2="14.5858"
        y2="1"
        stroke="#6C2AD2"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};

const getMuiTheme = (isDesktop = false) =>
  createTheme({
    typography: {
      fontFamily: 'Poppins',
    },

    components: {
      MuiTypography: {
        styleOverrides: {
          root: {
            fontFamily: 'Poppins',
          },
        },
      },

      MuiFormHelperText: {
        styleOverrides: {
          root: {
            fontFamily: 'Poppins',
          },
        },
      },

      MuiDialog: {
        styleOverrides: {
          paper: isDesktop
            ? {
                transform: `scale(${APP_SCALE})`,
                transformOrigin: 'center',
              }
            : {
                transform: 'none',
              },
        },
      },

      MuiPopover: {
        styleOverrides: {
          paper: isDesktop
            ? {
                transform: `scale(${APP_SCALE})`,
                transformOrigin: 'top left',
              }
            : {},
        },
      },

      MuiMenu: {
        styleOverrides: {
          paper: isDesktop
            ? {
                transform: `scale(${APP_SCALE})`,
                transformOrigin: 'top left',
              }
            : {},
        },
      },
    },
  });
const useStyles = makeStyles((theme) => ({
  CloseButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '52px !important',
    height: '49px !important',
    borderRadius: '10px !important',
    boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.15)',
    zIndex: 1,
    padding: '17px 18px 17px 18px !important',
    border: '1px solid #C1BDBD',
    background: '#fff !important',
    cursor: 'pointer',
    position: 'fixed !important',
    marginLeft: '-70px !important',
    color: '#000',
    [theme.breakpoints.down('lg')]: {
      marginLeft: '0px !important',
      // width: "42px",
      height: '39px',
      borderRadius: '10px !important',
      boxShadow: 'none',
      padding: '0px !important',
      border: '0px',
      // background: "transparent !important",
      cursor: 'pointer',
    },
  },
  DialogBox: {
    borderRadius: '10px !important',
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      right: 0, // Adjust this value to control the right position
      borderRadius: '10px !important',
    },
  },
  DialogContent: {
    padding: '0px 50px 50px 50px !important',
    [theme.breakpoints.down('lg')]: {
      padding: '20px !important',
    },
  },
  TabList: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('lg')]: {
      display: 'block',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  TabBox: {
    display: 'flex',
  },
  TabTitle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0px 10px 0px 10px',
    fontFamily: 'Poppins !important',
    fontSize: '16px !important',
    [theme.breakpoints.down('lg')]: {
      fontSize: '14px !important',
    },
  },
  TabIconBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  activeTab: {
    backgroundColor: 'white !important',
    border: '#6c2ad2 solid 1px !important',
    margin: '0px 5px 0px 5px',
    color: '#6c2ad2 !important',
    fontFamily: 'Poppins !important',
    fontSize: '16px !important',
    fontWeight: 400,
    display: 'flex',
    justifyContent: 'center !important',
    alignItems: 'center !important',
    [theme.breakpoints.down('md')]: {
      margin: '5px 0px 5px 0px',
    },
  },
  inactiveTab: {
    background: 'rgb(251, 251, 251)',
    color: '#666 !important',
    border: '1px solid #d9d9d9 !important',
    fontSize: '16px !important',
    fontWeight: 400,
    fontFamily: 'Poppins !important',
    margin: '0px 5px 0px 5px',
    display: 'flex',
    justifyContent: 'center !important',
    alignItems: 'center !important',
    ' &:hover': {
      backgroundColor: '#FFFFFF !important',
      color: '#6C2AD2',
      border: '1px solid #6C2AD2 !important ',
    },
    [theme.breakpoints.down('md')]: {
      margin: '5px 0px 5px 0px',
    },
  },

  completed: {
    backgroundColor: 'white !important',
    border: '#6c2ad2 solid 1px !important',
    color: '#6c2ad2 !important',
    margin: '0px 2px 0px 2px',
    fontSize: '16px',
    fontWeight: 400,
    display: 'flex',
    justifyContent: 'center !important',
    alignItems: 'center !important',
    [theme.breakpoints.down('md')]: {
      margin: '5px 0px 5px 0px',
    },
  },
  ModalTitle: {
    fontSize: '32px !important',
    fontWeight: 600,

    textAlign: 'left !important',
    fontStyle: 'normal !important',
    padding: '10px 0px 10px 0px !important',
    [theme.breakpoints.down('md')]: {
      fontSize: '25px !important',
      fontWeight: 600,

      textAlign: 'left !important',
      fontStyle: 'normal !important',
      padding: '10px 0px 10px 0px !important',
    },
  },
  customDialogTitle: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      display: 'none !impartant',
    },
  },
  customDialogTitleMobile: {
    display: 'none !impartant',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
    },
  },
}));
const Transition = React.forwardRef(function Transition(props, ref) {
  const classes = useStyles();
  return <Slide direction="left" ref={ref} {...props} />;
});
const Tab = ({ color }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        className="icon_color"
        cx="8.99999"
        cy="8.99999"
        r="7.33333"
        stroke={color}
        stroke-width="2"
      />
      <path
        className="icon_color"
        d="M7 8.96646L8.41421 10.3807L11.2426 7.55225"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};
export default function PropertyCreation({
  open,
  onClose,
  publishcard,
  unpublishcard,
  activityfun,
  fromHeader,
  isTop,
  pendingId,
  pendingTab,
  setPendingId,
  dashboardcount,
  pipelineId = 0,
  categoryId = 0,
  prefillData,
  pipelineTempId,
}) {
  const isDesktop = useMediaQuery(`(min-width:${DESKTOP_BREAKPOINT}px)`);
  const [value, setValue] = React.useState(0);
  const [agencyTrueEstimatePrice, setAgencyTrueEstimatePrice] =
    React.useState();
  const [legalSliderRange, setLegalSliderRange] = React.useState([0, 0]);
  const [ismediacompleted, setIsmediacompleted] = React.useState(false);
  const [moxovendorack, setMoxovendorack] = React.useState([]);
  const [moxoagentack, setMoxoagentack] = React.useState([]);
  const [getstreettype, setGetstreettype] = React.useState([]);
  const classes = useStyles();
  const theme = useTheme();
  const [tab, setTab] = React.useState('#666666');
  const [tabList, setTabList] = React.useState('1');
  const [responseData, setResponseData] = React.useState([]);
  const [responseProp, setResponseProp] = React.useState('');
  const [responseTempId, setResponseTempId] = React.useState(0);
  const sectionRef = React.useRef(null);
  const main = React.useRef(null);
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const [openResume, setOpenResume] = React.useState(false);
  const [resumePrefillData, setResumePrefillData] = React.useState(null);
  const [isResumed, setIsResumed] = React.useState(false);

  async function fetchResumePrefill() {
    const activePropertyId = pipelineTempId || pendingId || 0;
    if (activePropertyId > 0) {
      try {
        const inputData = { propertyId: activePropertyId };
        const response = await postApiCall(GET_APPRAISAL_PREFILL, inputData);
        if (response?.data?.status === 1) {
          const fetchedAddresses =
            response?.data?.propertyDetailsWithMedia || [];
          const details =
            fetchedAddresses.find(
              (p) => String(p.propertyId) === String(activePropertyId)
            ) || fetchedAddresses[0];

          if (details) {
            const ownerFromApi = details?.ownerDetails?.[0] || {};
            const prefillObj = {
              owner: {
                firstName: ownerFromApi.ownerFirstName || '',
                lastName: ownerFromApi.ownerSurName || '',
                email: ownerFromApi.ownerEmail || '',
                mobile: ownerFromApi.ownerMobileNo || '',
                companyName: ownerFromApi.companyName || '',
                legalName: ownerFromApi.legalName || '',
                ownershipType: ownerFromApi.ownershipType || '',
                ownerDetails: details?.ownerDetails || [],
              },
              property: details || null,
            };
            setResumePrefillData(prefillObj);
          }
        }
      } catch (err) {
        console.error(
          'Error fetching resume prefill in PropertyCreation:',
          err
        );
      }
    }
  }

  const handleResumeClose = () => {
    setOpenResume(false);
    setIsResumed(false);
    setResumePrefillData(null);
    setValue(0);
  };

  const handleContinue = async () => {
    setIsResumed(true);
    const newTab = pendingTab - 1;
    setValue(newTab);
    setOpenResume(false);
    if (pipelineTempId > 0) {
      await fetchResumePrefill();
    }
  };

  const activePrefillData = prefillData || resumePrefillData;

  //alternate solution to render page without flickering
  React.useLayoutEffect(() => {
    if (fromHeader === 'property') {
      setValue(2);
    }
    if (
      fromHeader == 'no' &&
      pendingId != 0 &&
      pendingId != undefined &&
      pendingTab != undefined
    ) {
      setOpenResume(true);
    }
  }, []);

  const isFirstRender = React.useRef(true);

  useEffect(() => {
    if (open) {
      getApiCall(STREET_TYPE_LIST).then((response) => {
        let data = [
          { streetType: 'Street', streetAbbrev: 'St' },
          { streetType: 'Road', streetAbbrev: 'Rd' },
          { streetType: 'Avenue', streetAbbrev: 'Ave' },
          { streetType: 'Lane', streetAbbrev: 'Ln' },
          { streetType: 'Highway', streetAbbrev: 'Hwy' },
          { streetType: 'Boulevard', streetAbbrev: 'Blvd' },
          { streetType: 'Crescent', streetAbbrev: 'Cres' },
        ];
        if (response?.data?.streetTypes) {
          response.data.streetTypes.forEach((item) => {
            data.push(item);
          });
        }
        const options = data.map((option) => {
          if (option?.streetType == 'Street') {
            return {
              label: option?.streetType,
              type: 'option',
              streetAbbrev: 'St',
            };
          }
          if (option?.streetType == 'Road') {
            return {
              label: option?.streetType,
              type: 'option',
              streetAbbrev: 'Rd',
            };
          }
          if (option?.streetType == 'Avenue') {
            return {
              label: option?.streetType,
              type: 'option',
              streetAbbrev: 'Ave',
            };
          }
          if (option?.streetType == 'Lane') {
            return {
              label: option?.streetType,
              type: 'option',
              streetAbbrev: 'Lane',
            };
          }
          if (option?.streetType == 'Highway') {
            return {
              label: option?.streetType,
              type: 'option',
              streetAbbrev: 'Hwy',
            };
          }
          if (option?.streetType == 'Boulevard') {
            return {
              label: option?.streetType,
              type: 'option',
              streetAbbrev: 'Bvd',
            };
          }
          if (option?.streetType == 'Crescent') {
            return {
              label: option?.streetType,
              type: 'option',
              streetAbbrev: 'Cres',
            };
          } else {
            return {
              label: option?.streetType,
              type: 'option',
              streetAbbrev: option?.streetAbbrev,
            };
          }
        });
        setGetstreettype(options);
      });
    }
  }, [open]);

  useEffect(() => {
    if (main.current) {
      main.current.scrollTop = 0;
    }
  }, [value]);

  const handleClose = () => {
    onClose();
    setValue(0);
    // dashboardcount();
  };
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const matches1200 = useMediaQuery(theme.breakpoints.down(1200));
  const handleChange = (event, newValue) => {
    setTabList(newValue);
  };

  useEffect(() => {
    let scrollY = 0;
    if (open) {
      scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.overflow = 'hidden';
      document.body.style.width = '100%';
    } else {
      // restore will happen in cleanup below
    }

    return () => {
      // restore
      const top = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.overflow = '';
      document.body.style.width = '';
      if (top) {
        const savedScroll = parseInt(top || '0') * -1;
        window.scrollTo(0, savedScroll);
      }
    };
  }, [open]);

  return (
    <ThemeProvider theme={getMuiTheme(isDesktop)}>
      <Dialog
        PaperProps={{
          className: classes.DialogBox,
          style: {
            width: matches1200 && '100%',
            borderRadius: '10px !important',
            overflow: 'visible',
            margin: 0,
          },
        }}
        sx={{
          marginTop: '80px',
          '& .MuiDialog-container': {
            justifyContent: 'flex-end', // 👈 push to right
            alignItems: 'flex-start', // if open at top
          },
          '& .MuiDialog-paper': isDesktop && {
            transform: `scale(${APP_SCALE})`,
            transformOrigin: 'top right',
            maxHeight: '100vh',
          },
        }}
        fullWidth={'xl'}
        maxWidth={'xl'}
        open={open}
      >
        <div ref={main} style={{ overflowY: 'auto', height: '100%' }}>
          <IconButton
            tabIndex="-1"
            className={classes.CloseButton}
            aria-label="Close"
            color="inherit"
            onClick={handleClose}
            sx={{
              minWidth: matches1200 && '100%',
              display: 'flex',
              justifyContent: 'start',
              gap: '20px',
            }}
          >
            {matches1200 && <Box>&nbsp;</Box>}
            <Close />
            {matches1200 && (
              <Typography
                sx={{
                  fontSize: '24px !important',
                  fontWeight: 600,
                  textAlign: 'left !important',
                }}
                ref={sectionRef}
              >
                {' '}
                Add Property
              </Typography>
            )}
          </IconButton>
          <DialogTitle
            style={{ display: isSmallScreen ? 'none' : 'block' }}
            className={classes.customDialogTitle}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <Box textAlign="center">
                  {!matches1200 && (
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={12}>
                        <Typography
                          style={{ fontWeight: 600 }}
                          className={classes.ModalTitle}
                        >
                          {' '}
                          {/* Add Listing  */}
                          {fromHeader == 'appraisal'
                            ? 'Appraisal'
                            : 'Add Property'}
                        </Typography>
                      </Grid>
                    </Grid>
                  )}
                  <Grid
                    container
                    spacing={2}
                    sx={{ marginTop: matches1200 && '30px' }}
                  >
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                      <List className={classes.TabList} value={value}>
                        {(fromHeader == 'owner' ||
                          fromHeader == 'no' ||
                          fromHeader == 'appraisal') && (
                          <ListItem
                            sx={{
                              borderBottomLeftRadius: '10px',
                              borderTopLeftRadius: '10px',
                            }}
                            className={
                              value >= 0
                                ? classes.activeTab
                                : classes.inactiveTab
                            }
                            // onClick={() => {
                            //   setValue(0);
                            // }}
                          >
                            <Box
                              // className={classes.TabBox}
                              sx={{
                                display: 'flex',
                                justifyContent: 'start',
                                marginLeft: '50px',
                                width: '180px',
                              }}
                            >
                              <Box
                                className={classes.TabIconBox}
                                onMouseEnter={() => {
                                  setTab('#6C2AD2');
                                }}
                                onMouseLeave={() => {
                                  setTab('#6C2AD2');
                                }}
                              >
                                <Tab color={value >= 0 ? '#6C2AD2' : ' #666'} />
                              </Box>
                              <Typography className={classes.TabTitle}>
                                Ownership
                              </Typography>
                            </Box>
                          </ListItem>
                        )}

                        {fromHeader == 'no' && (
                          <ListItem
                            className={
                              value >= 1
                                ? classes.activeTab
                                : classes.inactiveTab
                            }
                            // onClick={() => {
                            //   setValue(1);
                            // }}
                          >
                            <Box
                              // className={classes.TabBox}
                              sx={{
                                display: 'flex',
                                justifyContent: 'start',
                                marginLeft: '50px',
                                width: '180px',
                              }}
                            >
                              <Box
                                className={classes.TabIconBox}
                                onMouseEnter={() => {
                                  setTab('#6C2AD2');
                                }}
                                onMouseLeave={() => {
                                  setTab('#6C2AD2');
                                }}
                              >
                                <Tab color={value >= 1 ? '#6C2AD2' : ' #666'} />
                              </Box>
                              <Typography className={classes.TabTitle}>
                                {' '}
                                Legal Details
                              </Typography>
                            </Box>
                          </ListItem>
                        )}

                        {(fromHeader == 'property' ||
                          fromHeader == 'no' ||
                          fromHeader == 'appraisal' ||
                          value == 2) && (
                          <ListItem
                            className={
                              value >= 2 || fromHeader == 'property'
                                ? classes.activeTab
                                : classes.inactiveTab
                            }
                            // onClick={() => {
                            //   setValue(2);
                            // }}
                          >
                            <Box
                              // className={classes.TabBox}
                              sx={{
                                display: 'flex',
                                justifyContent: 'start',
                                marginLeft: '50px',
                                width: '180px',
                              }}
                            >
                              <Box
                                className={classes.TabIconBox}
                                onMouseEnter={() => {
                                  setTab('#6C2AD2');
                                }}
                                onMouseLeave={() => {
                                  setTab('#6C2AD2');
                                }}
                              >
                                <Tab
                                  color={
                                    value >= 2 || fromHeader == 'property'
                                      ? '#6C2AD2'
                                      : ' #666'
                                  }
                                />
                              </Box>
                              <Typography className={classes.TabTitle}>
                                Property Details
                              </Typography>
                            </Box>
                          </ListItem>
                        )}
                        {/* right next to property tab */}

                        {value == 0 && fromHeader == 'property' && (
                          <ListItem
                            sx={{
                              borderBottomLeftRadius: '10px',
                              borderTopLeftRadius: '10px',
                            }}
                            className={
                              value >= 0
                                ? classes.activeTab
                                : classes.inactiveTab
                            }
                            // onClick={() => {
                            //   setValue(0);
                            // }}
                          >
                            <Box
                              // className={classes.TabBox}
                              sx={{
                                display: 'flex',
                                justifyContent: 'start',
                                marginLeft: '50px',
                                width: '180px',
                              }}
                            >
                              <Box
                                className={classes.TabIconBox}
                                onMouseEnter={() => {
                                  setTab('#6C2AD2');
                                }}
                                onMouseLeave={() => {
                                  setTab('#6C2AD2');
                                }}
                              >
                                <Tab color={value >= 0 ? '#6C2AD2' : ' #666'} />
                              </Box>
                              <Typography className={classes.TabTitle}>
                                Ownership
                              </Typography>
                            </Box>
                          </ListItem>
                        )}
                        {fromHeader == 'no' && (
                          <ListItem
                            sx={{
                              borderBottomRightRadius: '10px',
                              borderTopRightRadius: '10px',
                            }}
                            className={
                              value >= 3
                                ? classes.activeTab
                                : classes.inactiveTab
                            }
                            // onClick={() => {
                            //   setValue(3);
                            // }}
                          >
                            <Box
                              // className={classes.TabBox}
                              sx={{
                                display: 'flex',
                                justifyContent: 'start',
                                marginLeft: '50px',
                                width: '180px',
                              }}
                            >
                              <Box
                                className={classes.TabIconBox}
                                onMouseEnter={() => {
                                  setTab('#6C2AD2');
                                }}
                                onMouseLeave={() => {
                                  setTab('#6C2AD2');
                                }}
                              >
                                <Tab color={value >= 3 ? '#6C2AD2' : ' #666'} />
                              </Box>
                              <Typography className={classes.TabTitle}>
                                retreX Campaign
                              </Typography>
                            </Box>
                          </ListItem>
                        )}
                        {/* <ListItem
                        sx={{
                          borderBottomRightRadius: "10px",
                          borderTopRightRadius: "10px",
                        }}
                        className={
                          value >= 4 ? classes.activeTab : classes.inactiveTab
                        }
                      >
                        <Box className={classes.TabBox}>
                          <Box
                            className={classes.TabIconBox}
                            onMouseEnter={() => {
                              setTab("#6C2AD2");
                            }}
                            onMouseLeave={() => {
                              setTab("#6C2AD2");
                            }}
                          >
                            <Tab color={value >= 4 ? "#6C2AD2" : " #666"} />
                          </Box>
                          <Typography className={classes.TabTitle}>
                            Due Diligence
                          </Typography>
                        </Box>
                      </ListItem> */}
                      </List>
                    </Grid>
                    <Grid></Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent
            className={classes.DialogContent}
            sx={{
              overflowY: 'scroll',
              '-webkit-scrollbar': {
                display: 'none',
              },
              '-ms-overflow-style': 'none' /* IE and Edge */,
              'scrollbar-width': 'none',
            }}
          >
            <Grid
              container
              spacing={2}
              style={{ display: isSmallScreen ? 'block' : 'none' }}
              className={classes.customDialogTitleMobile}
            >
              <Grid item xs={12} md={12}>
                <Box textAlign="center">
                  {/* {!matches1200&&<Grid gap={10} container spacing={2}>
                  <Grid item xs={12} md={12}>
                    <Typography
                      style={{ fontWeight: 600 }}
                      className={classes.ModalTitle}
                      sx={{marginTop:"20px"}}
                    >
                      {" "}
                      Add Listing
                    </Typography>
                  </Grid>
                </Grid>} */}
                  <Grid
                    container
                    spacing={2}
                    sx={{ marginTop: isSmallScreen && '30px' }}
                  >
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                      <List className={classes.TabList} value={value}>
                        {(fromHeader == 'owner' ||
                          fromHeader == 'no' ||
                          fromHeader == 'appraisal') && (
                          <ListItem
                            sx={{
                              borderBottomLeftRadius: '10px',
                              borderTopLeftRadius: '10px',
                            }}
                            className={
                              value >= 0
                                ? classes.activeTab
                                : classes.inactiveTab
                            }
                          >
                            <Box
                              // className={classes.TabBox}
                              sx={{
                                display: 'flex',
                                justifyContent: 'start',
                                marginLeft: '50px',
                                width: '180px',
                              }}
                            >
                              <Box
                                className={classes.TabIconBox}
                                onMouseEnter={() => {
                                  setTab('#6C2AD2');
                                }}
                                onMouseLeave={() => {
                                  setTab('#6C2AD2');
                                }}
                              >
                                <Tab color={value >= 0 ? '#6C2AD2' : ' #666'} />
                              </Box>
                              <Typography className={classes.TabTitle}>
                                Ownership
                              </Typography>
                            </Box>
                          </ListItem>
                        )}

                        {fromHeader == 'no' && (
                          <ListItem
                            className={
                              value >= 1
                                ? classes.activeTab
                                : classes.inactiveTab
                            }
                          >
                            <Box
                              // className={classes.TabBox}
                              sx={{
                                display: 'flex',
                                justifyContent: 'start',
                                marginLeft: '50px',
                                width: '180px',
                              }}
                            >
                              <Box
                                className={classes.TabIconBox}
                                onMouseEnter={() => {
                                  setTab('#6C2AD2');
                                }}
                                onMouseLeave={() => {
                                  setTab('#6C2AD2');
                                }}
                              >
                                <Tab color={value >= 1 ? '#6C2AD2' : ' #666'} />
                              </Box>
                              <Typography className={classes.TabTitle}>
                                {' '}
                                Legal Details
                              </Typography>
                            </Box>
                          </ListItem>
                        )}

                        {(fromHeader == 'property' ||
                          fromHeader == 'no' ||
                          fromHeader == 'appraisal' ||
                          value == 2) && (
                          <ListItem
                            className={
                              value >= 2 || fromHeader == 'property'
                                ? classes.activeTab
                                : classes.inactiveTab
                            }
                          >
                            <Box
                              // className={classes.TabBox}
                              sx={{
                                display: 'flex',
                                justifyContent: 'start',
                                marginLeft: '50px',
                                width: '180px',
                              }}
                            >
                              <Box
                                className={classes.TabIconBox}
                                onMouseEnter={() => {
                                  setTab('#6C2AD2');
                                }}
                                onMouseLeave={() => {
                                  setTab('#6C2AD2');
                                }}
                              >
                                <Tab
                                  color={
                                    value >= 2 || fromHeader == 'property'
                                      ? '#6C2AD2'
                                      : ' #666'
                                  }
                                />
                              </Box>
                              <Typography className={classes.TabTitle}>
                                Property Details
                              </Typography>
                            </Box>
                          </ListItem>
                        )}

                        {/* for ownertab next to property */}
                        {value == 0 && fromHeader == 'property' && (
                          <ListItem
                            sx={{
                              borderBottomLeftRadius: '10px',
                              borderTopLeftRadius: '10px',
                            }}
                            className={
                              value >= 0
                                ? classes.activeTab
                                : classes.inactiveTab
                            }
                            // onClick={() => {
                            //   setValue(0);
                            // }}
                          >
                            <Box
                              // className={classes.TabBox}
                              sx={{
                                display: 'flex',
                                justifyContent: 'start',
                                marginLeft: '50px',
                                width: '180px',
                              }}
                            >
                              <Box
                                className={classes.TabIconBox}
                                onMouseEnter={() => {
                                  setTab('#6C2AD2');
                                }}
                                onMouseLeave={() => {
                                  setTab('#6C2AD2');
                                }}
                              >
                                <Tab color={value >= 0 ? '#6C2AD2' : ' #666'} />
                              </Box>
                              <Typography className={classes.TabTitle}>
                                Ownership
                              </Typography>
                            </Box>
                          </ListItem>
                        )}

                        {fromHeader == 'no' && (
                          <ListItem
                            sx={{
                              borderBottomRightRadius: '10px',
                              borderTopRightRadius: '10px',
                            }}
                            className={
                              value >= 3
                                ? classes.activeTab
                                : classes.inactiveTab
                            }
                          >
                            <Box
                              // className={classes.TabBox}
                              sx={{
                                display: 'flex',
                                justifyContent: 'start',
                                marginLeft: '50px',
                                width: '180px',
                              }}
                            >
                              <Box
                                className={classes.TabIconBox}
                                onMouseEnter={() => {
                                  setTab('#6C2AD2');
                                }}
                                onMouseLeave={() => {
                                  setTab('#6C2AD2');
                                }}
                              >
                                <Tab color={value >= 3 ? '#6C2AD2' : ' #666'} />
                              </Box>
                              <Typography className={classes.TabTitle}>
                                retreX Campaign
                              </Typography>
                            </Box>
                          </ListItem>
                        )}
                        {/* <ListItem
                        sx={{
                          borderBottomRightRadius: "10px",
                          borderTopRightRadius: "10px",
                        }}
                        className={
                          value >= 4 ? classes.activeTab : classes.inactiveTab
                        }
                      >
                        <Box className={classes.TabBox}>
                          <Box
                            className={classes.TabIconBox}
                            onMouseEnter={() => {
                              setTab("#6C2AD2");
                            }}
                            onMouseLeave={() => {
                              setTab("#6C2AD2");
                            }}
                          >
                            <Tab color={value >= 4 ? "#6C2AD2" : " #666"} />
                          </Box>
                          <Typography className={classes.TabTitle}>
                            Due Diligence
                          </Typography>
                        </Box>
                      </ListItem> */}
                      </List>
                    </Grid>
                    <Grid></Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                {value === 0 && (
                  <AddListingModal
                    sectionRef={sectionRef}
                    value={value}
                    setValue={setValue}
                    onClose={onClose}
                    fromHeader={fromHeader}
                    responseData={responseData}
                    setResponseData={setResponseData}
                    responseProp={responseProp}
                    setResponseProp={setResponseProp}
                    responseTempId={responseTempId}
                    setResponseTempId={setResponseTempId}
                    dashboardcount={dashboardcount}
                    prefillData={activePrefillData}
                    pipelineTempId={pipelineTempId}
                  />
                )}

                {value === 1 && (
                  <LegalDetailsAdd
                    value={value}
                    setValue={setValue}
                    onClose={onClose}
                    options={getstreettype}
                    agencyTrueEstimatePrice={agencyTrueEstimatePrice}
                    setAgencyTrueEstimatePrice={setAgencyTrueEstimatePrice}
                    fromHeader={fromHeader}
                    resumeTempId={isResumed ? pendingId : undefined}
                    dashboardcount={dashboardcount}
                    setLegalSliderRange={setLegalSliderRange}
                    pipelineTempId={pipelineTempId}
                  />
                )}

                {value == 2 && (
                  <PropertyCreationAddListing
                    value={value}
                    setValue={setValue}
                    onClose={onClose}
                    options={getstreettype}
                    setMoxoagentack={setMoxoagentack}
                    setMoxovendorack={setMoxovendorack}
                    setIsmediacompleted={setIsmediacompleted}
                    agencyTrueEstimatePrice={agencyTrueEstimatePrice}
                    fromHeader={fromHeader}
                    responseData={responseData}
                    setResponseData={setResponseData}
                    responseProp={responseProp}
                    setResponseProp={setResponseProp}
                    responseTempId={responseTempId}
                    setResponseTempId={setResponseTempId}
                    resumeTempId={isResumed ? pendingId : undefined}
                    pendingTab={isResumed ? pendingTab : undefined}
                    dashboardcount={dashboardcount}
                    legalSliderRange={legalSliderRange}
                    // resumeTab={pendingTab}
                    pipelineId={pipelineId}
                    categoryId={categoryId}
                    prefillData={activePrefillData}
                    pipelineTempId={pipelineTempId}
                  />
                )}

                {value === 3 && (
                  <RetrexCampaign
                    value={value}
                    setValue={setValue}
                    onClose={onClose}
                    moxoagentack={moxoagentack}
                    moxovendorack={moxovendorack}
                    publishcard={publishcard}
                    unpublishcard={unpublishcard}
                    activityfun={activityfun}
                    ismediacompleted={ismediacompleted}
                    fromHeader={fromHeader}
                    resumeTempId={isResumed ? pendingId : undefined}
                    pendingTab={isResumed ? pendingTab : undefined}
                    dashboardcount={dashboardcount}
                    pipelineTempId={pipelineTempId}
                  />
                )}
                {/* {value === 4 && (
                <DueDiligence
                  value={value}
                  setValue={setValue}
                  onClose={onClose}
                /> 
                )} */}
              </Grid>
            </Grid>
          </DialogContent>
        </div>
      </Dialog>

      <Dialog
        open={openResume}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleResumeClose();
        }}
      >
        <DialogTitle
          id="continue-dialog-title"
          sx={{
            ...poppins500,
            fontSize: matchessm ? '12px' : '16px',
            color: '#0a0a0aff',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            gap: 1, // adds spacing between icon & text
          }}
        >
          <Pendingwarning />
          Resume Property Creation
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="continue-dialog-description"
            sx={{
              ...poppins400,
              fontSize: matchessm ? '12px' : '16px',
              color: '#666666',
              width: '100%',
            }}
          >
            Do you want to continue your unfinished property creation?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleResumeClose}
            variant="outlined"
            style={{
              padding: matchessm ? '6px 18px' : '10px 39px',
              width: '60px',
              height: matchessm ? '35px' : '41px',
              fontSize: matchessm ? '12px' : '14px',
              color: '#666666',
              fontWeight: '400',
              fontFamily: 'Poppins',
              border: '1px solid rgba(17, 35, 71, 0.1)',
              borderRadius: '5px',
              textTransform: 'none',
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleContinue}
            color="primary"
            autoFocus
            variant="outlined"
            style={{
              padding: matchessm ? '7px 17px' : '10px 39px',
              width: '60px',
              height: matchessm ? '35px' : '41px',
              fontSize: matchessm ? '12px' : '14px',
              color: '#FFFFFF',
              fontWeight: '400',
              fontFamily: 'Poppins',
              background: '#4CA4D6',
              borderRadius: '5px',
              textTransform: 'none',
            }}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
}
